// import { BASE_API_URL } from 'react-native-dotenv';

// npm start and builds use production; npm run start:stage points these at
// staging (scripts/react-scripts.js).
const ApiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || "https://api.hashh.io/",
  authUrl: process.env.REACT_APP_AUTH_URL || "https://auth.hashh.io/auth/",
  // The broker an energy meter's live readings come from (the app's
  // CommonSwichDetails.js), over MQTT on a secure websocket.
  mqttUrl: process.env.REACT_APP_MQTT_URL || "wss://mqtt1.hashh.io/mqtt",
  urls: {
    user: "user",
    mqttCredentials: "mqtt/credentials",
    userPolicy: "userpolicy",
    getConfigById: "config",
    getTimeline: "logs/date-range",
    getDoorStatusForDay: "logs/openCloseStatusForDay",
    getDoorStatusForMonth: "logs/openCloseStatusForMonth",
    getDoorStatusForYear: "logs/openCloseStatusForYear",
    getProperty: "property",
    getRooms: "config",
    getDeviceTypes: "config",
    updateConfig: "config",
    updateState: "control",
    getLastState: "laststate",
    registerDevice: "device",
    deleteDevice: "device/property",
    automation: "automation",
    subscription: "subscription",
    notification: "notification",
    activity: "activity",
    warranty: "warranty",
    getKwhByMonth: "logs/kwhmonth-range",
    getWattsByLastOneHour: "logs/wattslastonehour-range",
    getKwhByWeek: "logs/kwhweek-range",
    runtimeForDay: "logs/runtimeForDay",
    runtimeForMonth: "logs/runtimeForMonth",
    runtimeForYear: "logs/runtimeForYear",
    energyTelemetry: "logs/latestTelemetry",
    energyHistoryRange: "logs/energyHistoryRange",
    energyMeterExpense: "logs/energyCost",
    getHIKCodes: (propertyId) => `hikvision/${propertyId}/codes`,
    getHIKAccessToken: (propertyId) => `hikvision/${propertyId}/token`,
    addHIKDevice: (propertyId) => `hikvision/${propertyId}/device`,
    deleteHIKDevice: (propertyId, deviceID) =>
      `hikvision/${propertyId}/device/${deviceID}`,
    getRemoteCategories: () =>
      `irdb/categories?from=${0}&count=${14}&status=${1}`,
    getRemoteBrands: (categoryId, searchText, from, count) =>
      `irdb/brands?categoryId=${categoryId}&from=${from}${
        searchText?.length !== 0 ? `&search=${searchText}` : ""
      }&count=${count}`,
    getRemotes: (categoryId, brandId) =>
      `irdb/remotes?categoryId=${categoryId}&from=${0}&brandId=${brandId}`,
    decodeRemote: "irdb/decode",
    decodeRemoteById: (propertyId, remoteId) =>
      `irdb/remote/${propertyId}/data/${remoteId}`,
    addRemote: (propertyId) => `irdb/remote/add/${propertyId}`,
    getRemoteData: (propertyId, remoteId) =>
      `irdb/remote/${propertyId}/data/${remoteId}`,
    deleteRemote: (propertyId, remoteId) =>
      `irdb/remote/${propertyId}/delete/${remoteId}`,
    renameRemote: (propertyId) => `irdb/remote/${propertyId}/rename`,
    updateRemoteKey: (propertyId, remoteId) =>
      `irdb/remote/${propertyId}/key/${remoteId}`,
  },
};

export default ApiConfig;
